import { useEffect, useState } from 'react';

const ViewIngredient = ({ ingredients, total }) => {
  const [list, setList] = useState([]);
  const [totalCalories, setTotalCalories] = useState({
    calories: 0,
    proteins: 0,
    carbohydrates: 0,
    fats: 0,
  });

  useEffect(() => {
    setList(ingredients);
    setTotalCalories(total);
  }, []);

  return (
    <div className=''>
      <div className='mb-8'>
        <div className='opacity-40'>Your plate</div>
        <div className='text-xl font-bold text-accent'>
          {totalCalories.calories} Cal
        </div>
      </div>
      <div className='divide-y divide-tertiary space-y-4 max-h-96 overflow-auto scrollbar-hidden rounded-xl'>
        {list.map((item, i) => (
          <div
            key={i}
            className='pt-4'
          >
            <div className='flex gap-2 items-center mb-2 px-1'>
              <div className='font-bold'>{item.name}</div>
              <div className='opacity-40'>{item.portion} g</div>
            </div>
            <div className='grid grid-cols-2 gap-1'>
              <div className='flex justify-between items-center border rounded-full px-2 py-1 bg-tertiary/30'>
                <div>Calories</div>
                <div>{item.calories} Cal</div>
              </div>
              <div className='flex justify-between items-center border rounded-full px-2 py-1 border-protein bg-protein/30'>
                <div>Protein</div>
                <div>{item.proteins} g</div>
              </div>
              <div className='flex justify-between items-center border rounded-full px-2 py-1 border-carbs bg-carbs/30'>
                <div>Carbs</div>
                <div>{item.carbohydrates} g</div>
              </div>
              <div className='flex justify-between items-center border rounded-full px-2 py-1 border-fats bg-fats/30'>
                <div>Fat</div>
                <div>{item.fats} g</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ViewIngredient;
